import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLanguageComponent } from './select-language/select-language.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateService } from '../services/custom-translate.service';

import { FlexLayoutModule } from '@angular/flex-layout';
import { IonicModule } from '@ionic/angular';
import { PermissionMessageComponent } from './permission-message/permission-message.component';

// import { MatExpansionModule } from '@angular/material/expansion';
import { ModelPopupComponent } from './model-popup/model-popup.component';
// import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';

// import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
// import { MatCardModule } from '@angular/material/card';

// import { MatTooltipModule } from '@angular/material/tooltip';
@NgModule({
  declarations: [SelectLanguageComponent, ModelPopupComponent, PermissionMessageComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    IonicModule.forRoot(),
    // MatExpansionModule,
    // MatCardModule,
    // MatTooltipModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateService
      }, isolate: false, extend: true
    })
  ],
  exports: [PermissionMessageComponent,
    // MatExpansionModule
  ]
})
export class SharedModule { }
